import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingBox = () => {
  return (
    <div className="container">
      <Spinner />
    </div>
  );
};

export default LoadingBox;
